import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "notificationAlert" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-bell fa-2x",
  style: {"color":"#7FD6DC"}
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "notificationPallino"
}
const _hoisted_4 = {
  key: 0,
  class: "notificationContainer"
}
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center p-2" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Refresh ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-refresh" }, null, -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "modalCloser m-0" }
const _hoisted_10 = { class: "pointer" }
const _hoisted_11 = {
  key: 0,
  class: "d-flex justify-content-center p-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_comments = _resolveComponent("comments")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "pointer",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onNotificationClick && _ctx.onNotificationClick(...args)))
    }, [
      _hoisted_2,
      (_ctx.newNotificationCount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.newNotificationCount), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showNotifications)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-primary",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)), ["stop"]))
            }, _hoisted_8),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, [
                _createElementVNode("i", {
                  class: "fa fa-times",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onNotificationClick && _ctx.onNotificationClick(...args)))
                })
              ])
            ])
          ]),
          _createVNode(_component_comments, {
            comments: _ctx.notifications,
            removable: true,
            "remove-cb": _ctx.removeNotification,
            "always-removable": true
          }, null, 8, ["comments", "remove-cb"]),
          (_ctx.canLoadMore)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-primary",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.getNotifications && _ctx.getNotifications(...args)), ["stop"]))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Carica altri",
                    text: "Carica altri"
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}